module.exports = __webpack_public_path__ + "static/media/e16.9f7f73c7.jpg";